import script from "./PoliticaCookies.vue?vue&type=script&setup=true&lang=js"
export * from "./PoliticaCookies.vue?vue&type=script&setup=true&lang=js"

import "./PoliticaCookies.vue?vue&type=style&index=0&id=65f2a949&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65f2a949"]])

export default __exports__